module.exports = __webpack_public_path__ + "img/mc-lr-ny1.8dc11894.gif";